oyc.SlickSlider = {
  sliderElem: $('.is-slider'),
  defaultOptions: {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    mobileFirst: true,
  },

  sliderConfigs: [
    {
      selector: '.process-list',
      options: function () {
        const slider = $(this);
        return {
          ...oyc.SlickSlider.defaultOptions,
          infinite: false,
          variableWidth: true,
          adaptiveHeight: false,
          draggable: true,
          dots: true,
          appendArrows: slider.parent().find('.slider-control'),
          appendDots: slider.parent().find('.slider-control'),
          responsive: [
            {
              breakpoint: 9999,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              settings: {
                dots: false,
                appendDots: slider,
                appendArrows: slider,
              }
            }
          ]
        };
      }
    },
    {
      selector: '.quote-list',
      options: function () {
        const slider = $(this);
        return {
          ...oyc.SlickSlider.defaultOptions,
          infinite: false,
          draggable: true,
          dots: true,
          adaptiveHeight: true,
          appendArrows: slider.parent().find('.slider-control'),
          appendDots: slider.parent().find('.slider-control'),
          variableWidth: true,
          responsive: [
            {
              breakpoint: 9999,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              settings: {
                variableWidth: false,
                appendDots: slider,
                appendArrows: slider
              }
            }
          ]
        };
      }
    },
    {
      selector: '.media-gallery-list.is-first-version',
      options: function () {
        const slider = $(this);
        return {
          ...oyc.SlickSlider.defaultOptions,
          infinite: false,
          draggable: true,
          dots: true,
          adaptiveHeight: true,
          appendArrows: slider.parent().find('.slider-control'),
          appendDots: slider.parent().find('.slider-control'),
          variableWidth: true,
          responsive: [
            {
              breakpoint: 9999,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              settings: {
                variableWidth: false,
                appendDots: slider,
                appendArrows: slider
              }
            }
          ]
        };
      }
    },
    {
      selector: '.media-gallery-list.is-second-version',
      options: function () {
        const slider = $(this);
        return {
          ...oyc.SlickSlider.defaultOptions,
          infinite: false,
          variableWidth: true,
          adaptiveHeight: false,
          draggable: true,
          dots: true,
          appendArrows: slider.parent().find('.slider-control'),
          appendDots: slider.parent().find('.slider-control'),
          responsive: [
            {
              breakpoint: 9999,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              settings: {
                dots: false,
                appendDots: slider,
                appendArrows: slider,
              }
            }
          ]
        };
      }
    },
    {
      selector: '.subcompany-list',
      breakpoint: 1600,
      options: function () {
        const slider = $(this);
        return {
          ...oyc.SlickSlider.defaultOptions,
          infinite: false,
          variableWidth: true,
          adaptiveHeight: false,
          draggable: true,
          dots: true,
          appendArrows: slider.parent().find('.slider-control'),
          appendDots: slider.parent().find('.slider-control'),
          responsive: [
            {
              breakpoint: 768,
              settings: {
                dots: false,
                appendDots: slider,
                appendArrows: slider,
              }
            }
          ]
        };
      }
    },
  ],

  init: function () {
    this.initSliders();

    $(window).on('resize', this.handleResize.bind(this));
  },

  initSliders: function () {
    this.sliderConfigs.forEach(config => {
      this.sliderElem.filter(config.selector).each(function () {
        const slider = $(this);
        if (!slider.hasClass('slick-initialized') && (!('breakpoint' in config) || window.innerWidth < config.breakpoint)) {
          slider.on('init', function (event, slick) {
            if (slider.is('.quote-list')) {
              setTimeout(function () {
                slider.find('.slick-list.draggable').css('height', 'auto');
              }, 200);
            }
          });

          slider.slick(config.options.call(this));
        }
      });
    });
  },

  handleResize: function () {
    this.sliderConfigs.forEach(config => {
      const slider = this.sliderElem.filter(config.selector);
      const breakpoint = config.breakpoint ?? config.options().responsive[0].breakpoint;

      if (window.innerWidth < breakpoint) {
        if (!slider.hasClass('slick-initialized')) {
          slider.slick(config.options.call(slider[0]));
        }
      } else {
        // Viewport ist gleich oder größer als der konfigurierte Breakpoint
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
      }
    });
  }
}
